module.exports = __webpack_public_path__ + "Framel-c800a44d.webp";